// Presentación compartida de los estados granulares del import ARCA (backend §4.7).
// La usan el listado de pendientes (ListadoPendientesArca) y el resumen del modal
// de importación (ImportarArcaDialog), para que ambos muestren los mismos labels/colores.
export const ESTADOS_META = {
  registrado: { label: "Registrado", color: "success", variant: "filled" },
  sin_proveedor: {
    label: "Alta proveedor",
    color: "warning",
    variant: "outlined",
    tip: "El CUIT del emisor no está dado de alta en Proveedores. Compras debe darlo de alta (el padrón puede autocompletarlo) antes de registrar el comprobante.",
  },
  tipo_no_mapeado: { label: "Tipo no mapeado", color: "default", variant: "outlined" },
  falta_datos_factura: { label: "Faltan datos", color: "default", variant: "outlined" },
  falta_condicion_venta: { label: "Falta Con. Venta", color: "warning", variant: "outlined" },
  falta_imputacion: {
    label: "Falta imputación",
    color: "warning",
    variant: "outlined",
    tip: "El proveedor existe pero no tiene una imputación por defecto. Compras debe asignar la imputación de las líneas al registrar el comprobante.",
  },
  imputacion_ambigua: {
    label: "Imputación ambigua",
    color: "warning",
    variant: "outlined",
    tip: "El proveedor tiene más de una imputación posible. Compras debe elegir cuál corresponde al registrar el comprobante.",
  },
  completo: { label: "Listo", color: "success", variant: "outlined" },
};

// Orden de aparición (prioridad del backend); registrado primero.
export const ORDEN_ESTADOS = [
  "registrado",
  "sin_proveedor",
  "tipo_no_mapeado",
  "falta_datos_factura",
  "falta_condicion_venta",
  "falta_imputacion",
  "imputacion_ambigua",
  "completo",
];
